const formatLabel = {
  creation: 'created the equipment.',
  changeStatusT: 'inactivated',
  changeStatusT1: 'the equipment.',
  changeStatusF: 'reactivated',
  changeStatusF1: 'the equipment.',
  changeMaintenanceStatusT: 'returned',
  changeMaintenanceStatusT1: 'the maintenance equipment.',
  changeMaintenanceStatusF: 'You sent',
  changeMaintenanceStatusF1: 'the equipment for maintenance.',
  changePlace: ' modified the location of ',
  changePlace1: ' to ',
  changePlace2: ' removed the place ',
  changePlace3: ' of the equipment.',
  changePlace4: ' modified the location to ',
  changeSite: ' modified the site of ',
  changeSite1: ' to ',
  changeSite2: ' removed the site ',
  changeSite3: ' of the equipment.',
  changeSite4: ' modified the site to ',
  changePhoto: ' modified the photo.',
  changeEquipmentModel: ' updated the equipment type of ',
  changeEquipmentModel1: ' to ',
  changeEquipmentModel2: ' removed the equipment type ',
  changeEquipmentModel3: ' modified the equipment type to ',
  changeCompany: ' updated the company of ',
  changeCompany1: ' to ',
  changeCompany2: ' removed the company ',
  changeCompany3: ' of the equipment.',
  changeCompany4: ' modified the company to ',
  changeReference: ' updated the reference point ',
  changeReference1: 'from ',
  changeReference2: ' to ',
  changeSerialNumber: ' updated serial number ',
  changeSerialNumber1: 'from ',
  changeSerialNumber2: ' to ',
  changeDescription: ' updated equipment specifications ',
  changeDescription1: 'from ',
  changeDescription2: ' to ',
  changeBrand: ' updated the equipment brand ',
  changeBrand1: 'from ',
  changeBrand2: ' to ',
  changeBrand3: ' updated the brand of equipment to ',
  default: 'This equipment has been updated.',
  removedCompanies: 'removed the companies',
  removedCompany: 'removed the company',
  addedCompanies: 'added the companies',
  addedCompany: 'added the company',
  andString: 'and',
};

export default formatLabel;
